import { render, staticRenderFns } from "./TwoFactorStep.vue?vue&type=template&id=8c93448e"
import script from "./TwoFactorStep.vue?vue&type=script&lang=js"
export * from "./TwoFactorStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports